import React, { FunctionComponent } from "react";

import { FlexDirection, FlexGrow, Layout } from "@multiweb/reactComponents";
import { QAProps } from "@multiweb/types/react";
import { NavigationSection } from "../../navigation";
import { FormItem } from "../FormItem";

export type FormListComponentProps = {
    /** Identifikátory formulářů */
    subtreeNodeIds: readonly number[];
    /** Sekce, ve které je položka vykreslená. Slouží pro určování zaměření. */
    section: NavigationSection;
} & QAProps;

/** Komponenta slouží pro vykreslení množiny formulářových položek menu. */
export const FormListComponent: FunctionComponent<FormListComponentProps> = ({ subtreeNodeIds, section, qa }) => (
    <Layout
        flexDirection={FlexDirection.column}
        flexGrow={FlexGrow.one}
    >
        {subtreeNodeIds.map((subtreeNodeId: number) => (
            <FormItem
                key={subtreeNodeId}
                formItemId={subtreeNodeId}
                section={section}
                qa={qa}
            />
        ))}
    </Layout>
);
